<template>
  <div id="member-information">
    <div
      v-if="memberships.data.length && !isLoading"
      class="text-center mt-8"
    >
      <h2
        class="font-bold text-white"
        v-text="'Member Information'"
      />
      <p
        class="text-white text-sm mt-0"
        v-text="'Manage all of your organization membership details below'"
      />
    </div>
    <div
      v-if="memberships.data.length"
      class="tabs"
      :class="{ 'load load--fill': isLoading }"
    >
      <ul class="tabs__tab md:inline-flex bg-white">
        <li
          v-for="(membership, index) in memberships.data"
          :key="membership.uuid"
          :class="{ 'current': index === activeIndex }"
        >
          <a
            id="tab-name"
            href="#"
            :aria-selected="activeIndex === index"
            @click.prevent="setActiveIndex(index)"
            v-text="membership.union.attributes.name"
          />
        </li>
      </ul>
      <div class="tabs__tab_content bg-white">
        <div
          v-for="(membership, index) in memberships.data"
          v-show="activeIndex === index"
          :key="membership.uuid"
          :aria-hidden="activeIndex === index"
          aria-labelledby="tab-name"
          class="px-6"
        >
          <MembershipForm
            ref="memberships"
            :membership="membership"
          />
        </div>
      </div>
    </div>
    <div
      v-if="!memberships.data.length && !isLoading"
      class="text-center"
    >
      <h3
        class="text-white"
        v-text="`You're not currently associated with any organizations`"
      />
    </div>
  </div>
</template>

<script type="text/babel">
import MembershipForm from './MembershipForm'

export default {
  name: 'MembershipList',
  components: {
    MembershipForm,
  },
  props: {
    organizationUuid: {
      type: [String, Boolean],
      required: false,
      default: false,
    },
    userUuid: {
      type: [String, Boolean],
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      memberships: {
        data: [],
      },
      activeIndex: 0,
    }
  },
  computed: {
    baseUrl() {
      return this.userUuid ? `/users/${this.userUuid}/memberships` : '/me/memberships'
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.isLoading = true

      this.$api.public().get(`${this.baseUrl}?include=union,addresses,phoneNumbers,emergencyContacts,customMembershipFields,selfAssignableGroups,union`)
        .then(({ data }) => {
          this.memberships = data

          this.memberships.data = _.sortBy(this.memberships.data, ((membership) => {
            return membership.union.attributes.name
          }))

          this.isLoading = false

          this.$emit('membershipsLoaded')

          if (this.organizationUuid) {
            const index = this.memberships.data.findIndex(membership => membership.union.uuid === this.organizationUuid)

            if (index > -1) {
              this.setActiveIndex(index)
            }

            setTimeout(() => document.getElementById('member-information').scrollIntoView({
              behavior: 'smooth',
            }), 500)
          }
        })
    },
    setActiveIndex(index) {
      this.activeIndex = index
    },
  },
}
</script>
